export default function (Vue) {
    Vue.convert = {
        toURLEncoded(element, key, list) {
            var listResult = list || [];

            if (typeof (element) == 'object') {
                for (var idx in element)
                    this.toURLEncoded(element[idx], key ? key + '[' + idx + ']' : idx, listResult);
            } else {
                listResult.push(key + '=' + encodeURIComponent(element));
            }

            return listResult.join('&');
        }
    }

    Object.defineProperties(Vue.prototype, {
        $convert: {
            get() {
                return Vue.convert;
            }
        }
    })

}